package br.com.vvrefeicoes.portal.core.util

import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atTime
import kotlinx.datetime.format.Padding
import kotlinx.datetime.format.char
import kotlinx.datetime.minus
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.todayIn
import kotlin.time.Clock

interface DateTimeProvider {
    fun currentPeriod(): MonthPeriod

    fun today(): LocalDate

    fun nowTimestamp(): String

    fun daysAgo(days: Int): LocalDate = today().minus(days, DateTimeUnit.DAY)

    fun timestampDaysAgo(
        days: Int,
        hour: Int,
        minute: Int,
    ): String = timestampFormat.format(daysAgo(days).atTime(hour, minute))

    fun isoDaysAgo(
        days: Int,
        hour: Int,
        minute: Int,
    ): String = isoDateTimeFormat.format(daysAgo(days).atTime(hour, minute))

    fun dateDaysAgo(days: Int): String = dateFormat.format(daysAgo(days))
}

class SystemDateTimeProvider(
    private val clock: Clock = Clock.System,
    private val timeZone: TimeZone = TimeZone.currentSystemDefault(),
) : DateTimeProvider {
    override fun currentPeriod(): MonthPeriod {
        val date = today()
        return MonthPeriod(year = date.year, month = date.month.number)
    }

    override fun today(): LocalDate = clock.todayIn(timeZone)

    override fun nowTimestamp(): String = timestampFormat.format(clock.now().toLocalDateTime(timeZone))
}

private val timestampFormat =
    LocalDateTime.Format {
        day(padding = Padding.ZERO)
        char('/')
        monthNumber(padding = Padding.ZERO)
        char('/')
        year()
        char(' ')
        char('à')
        char('s')
        char(' ')
        hour(padding = Padding.ZERO)
        char(':')
        minute(padding = Padding.ZERO)
    }

private val isoDateTimeFormat =
    LocalDateTime.Format {
        year()
        char('-')
        monthNumber(padding = Padding.ZERO)
        char('-')
        day(padding = Padding.ZERO)
        char('T')
        hour(padding = Padding.ZERO)
        char(':')
        minute(padding = Padding.ZERO)
    }

private val dateFormat =
    LocalDate.Format {
        day(padding = Padding.ZERO)
        char('/')
        monthNumber(padding = Padding.ZERO)
        char('/')
        year()
    }
